// import React from 'react';
// import AliceCarousel from 'react-alice-carousel';
// import 'react-alice-carousel/lib/alice-carousel.css';

// class MultiCarouselPage extends React.Component {

//     render() {

//         return (

//             <AliceCarousel
//                 swipeDisabled={true}
//                 mouseTracking
//                 items={this.props.data}
//                 responsive={this.props.responsive}
//             // disableButtonsControls={true}

//             />


//         )
//     }
// }

// export default MultiCarouselPage



import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// itemClass = "carousel-item-padding-40-px"
class MultiCarouselPage extends React.Component {

    render() {

        return (

            <div style={{ "width": '100%' }}>
                <Carousel
                    responsive={this.props.responsive}
                    draggable={false}
                    partialVisible={true}
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    itemClass="p-1"
                >
                    {this.props.data}
                </Carousel>
            </div>

        )
    }
}

export default MultiCarouselPage

